// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CampaignCustomFieldListResultModel from '../../model/campaign-custom-field-list-result-model';
import CampaignCustomFieldListResultDTO from '../dto/campaign-custom-field-list-result-dto';
import CampaignCustomFieldModel from '../../model/campaign-custom-field-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CampaignCustomFieldListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CampaignCustomFieldListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CampaignCustomFieldModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  'items'?: CampaignCustomFieldModel[];
  /**
  */
  'links'?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<CampaignCustomFieldListResultDTO>): CampaignCustomFieldListResultModel;
  static toModel(dto: DeepPartial<CampaignCustomFieldListResultDTO> | undefined | null): CampaignCustomFieldListResultModel | undefined;
  static toModel(dto: DeepPartial<CampaignCustomFieldListResultDTO> | undefined | null): CampaignCustomFieldListResultModel | undefined {
    return dto ? new CampaignCustomFieldListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CampaignCustomFieldListResultModel> | CampaignCustomFieldListResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
    } as CampaignCustomFieldListResultDTO;
  }
}
